import './SearchBar.scss';

import { Form } from 'react-bootstrap';

interface Props {
  handleChange: any;
  clearSearch: any;
  value: string;
  placeholder: string;
}

/* All events will be handle by parent */
const SearchBar = (props: Props) => {
  return (
    <div className="search">
      <Form.Control
        id="search"
        className="input-search"
        placeholder={props.placeholder}
        onChange={props.handleChange}
        inputMode="search"
        value={props.value}
      />
      <div className="icon-cross" onClick={props.clearSearch} />
    </div>
  );
};
export default SearchBar;
